import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import BigButton from '../components/BigButton';
import { wordsData, categories } from '../data/words';
import { useSpeech } from '../hooks/useSpeech';
import './Words.css';

const WordCategory = () => {
    const { category } = useParams();
    const history = useHistory();
    const { speak } = useSpeech();

    const categoryInfo = categories.find(c => c.id === category);
    const words = wordsData[category] || [];

    if (!categoryInfo) return <Layout title="Error">Category not found</Layout>;

    return (
        <Layout title={categoryInfo.label} onBack={() => history.push('/words')}>
            <div className="words-grid">
                {words.map((item) => (
                    <BigButton
                        key={item.id}
                        label={item.label}
                        icon={item.emoji}
                        color={item.color}
                        onClick={() => speak(item.label)}
                    />
                ))}
            </div>
        </Layout>
    );
};

export default WordCategory;
